import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRebates = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 26a2 2 0 0 1-2-1.85V20.9a2 2 0 0 1 1.44-1.92l.33-.08a3 3 0 0 0 0-5.8l-.33-.08A2 2 0 0 1 2 11.27V8a2 2 0 0 1 1.85-2H28a2 2 0 0 1 2 1.85v3.25a2 2 0 0 1-1.44 1.92l-.33.08a3 3 0 0 0 0 5.8l.33.08A2 2 0 0 1 30 20.73l.01.17V24a2 2 0 0 1-1.85 2H4Zm7-18H4v3.1l.22.05a5 5 0 0 1 0 9.7L4 20.9V24h7V8Zm17 0H13v16h15v-3.1a5 5 0 0 1-.22-9.75l.22-.05V8Z" })
});
export default SvgRebates;
